'use strict';exports.__esModule = true;exports.createCustomInfoWindow = undefined;
var _reactDom = require('react-dom');var _reactDom2 = _interopRequireDefault(_reactDom);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/**
                                                                                                                                        * Create a custom overlay for our window marker display, extending google.maps.OverlayView.
                                                                                                                                        * This is somewhat complicated by needing to async load the google.maps api first - thus, we
                                                                                                                                        * wrap CustomWindow into a closure, and when instantiating CustomWindow, we first execute the closure (to create
                                                                                                                                        * our CustomWindow function, now properly extending the newly loaded google.maps.OverlayView), and then
                                                                                                                                        * instantiate said function.
                                                                                                                                        * Note that this version uses jQuery.
                                                                                                                                        * @type {Function}
                                                                                                                                        */
var createCustomInfoWindow = exports.createCustomInfoWindow = function createCustomInfoWindow(googleMapsInstance) {return function () {
    var CustomWindow = function CustomWindow() {
      var arrow = document.createElement('div');
      arrow.classList.add('map-info-arrow');
      arrow.appendChild(document.createElement('div'));
      arrow.appendChild(document.createElement('div'));
      var content = document.createElement('div');
      content.classList.add('map-info-content');

      this.container = document.createElement('div');
      this.container.classList.add('map-info-window');
      this.container.appendChild(arrow);
      this.container.appendChild(content);
      this.layer = null;
      this.marker = null;
      this.position = null;
    };

    /**
        * Inherit from OverlayView
        * @type {google.maps.OverlayView}
        */
    CustomWindow.prototype = new googleMapsInstance.OverlayView();

    /**
                                                                    * Called when this overlay is set to a map via this.setMap. Get the appropriate map pane
                                                                    * to add the window to, append the container, bind to close element.
                                                                    * @see CustomWindow.open
                                                                    */
    CustomWindow.prototype.onAdd = function () {var _this = this;
      this.layer = this.getPanes().floatPane;
      this.layer.appendChild(this.container);

      googleMapsInstance.OverlayView.preventMapHitsFrom(this.container);
      googleMapsInstance.OverlayView.preventMapHitsAndGesturesFrom(this.container);

      var closeButton = this.container.querySelector('.map-info-close');

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          // Close info window on click
          _this.close();
        }, false);
      }
    };

    function getDistanceBetweenPointAndMapBorders(map, point, mapHeightPixel, mapWidthPixel) {
      var mapBounds = map.getBounds();
      var mapNEPoint = mapBounds.getNorthEast();
      var mapSWPoint = mapBounds.getSouthWest();
      var mapHeight = mapSWPoint.lat() - mapNEPoint.lat();
      var mapWidth = mapNEPoint.lng() - mapSWPoint.lng();
      var pointOffsetTop = point.lat() - mapNEPoint.lat();
      var pointOffsetLeft = point.lng() - mapSWPoint.lng();
      var pointOffsetRight = mapNEPoint.lng() - point.lng();

      var distancesInPixel = {
        top: pointOffsetTop * mapHeightPixel / mapHeight,
        left: pointOffsetLeft * mapWidthPixel / mapWidth,
        right: pointOffsetRight * mapWidthPixel / mapWidth };


      return distancesInPixel;
    }

    function calculateInfoWindowPosition(pinOffsets, infoWindowHeight, infoWindowWidth) {var

      arrowHeight = _constants.pinInfoWindowMetrics.ARROW_HEIGHT,
      defaultOffsetY = _constants.pinInfoWindowMetrics.DEFAULT_OFFSET_Y,
      reverseOffsetY = _constants.pinInfoWindowMetrics.REVERSE_OFFSET_Y,
      margin = _constants.pinInfoWindowMetrics.MARGIN;


      var offsetX = infoWindowWidth / 2;
      var offsetY = defaultOffsetY - infoWindowHeight;
      var isArrowAtTop = false;

      if (pinOffsets.top < infoWindowHeight + arrowHeight - defaultOffsetY) {
        isArrowAtTop = true;
        offsetY = arrowHeight + reverseOffsetY;
      }

      if (pinOffsets.left < infoWindowWidth / 2 + margin) {
        offsetX = pinOffsets.left - infoWindowWidth / 2 - margin + infoWindowWidth / 2;
      }

      if (pinOffsets.right < infoWindowWidth / 2 + margin) {
        offsetX = infoWindowWidth / 2 + margin - pinOffsets.right + infoWindowWidth / 2;
      }

      return {
        isArrowAtTop: isArrowAtTop,
        offsetX: offsetX,
        offsetY: offsetY };

    }

    function calculateArrowPosition(mapWidth, infoWindowWidth, pinOffsetLeft, infoWindowOffsetX) {
      var margin = (mapWidth - infoWindowWidth) / 2;
      var arrowOffsetLeft = window.screen.width < 768 ? pinOffsetLeft - margin : infoWindowOffsetX;

      return arrowOffsetLeft - _constants.pinInfoWindowMetrics.ARROW_WIDTH / 2 + 'px';
    }

    /**
       * Called after onAdd, and every time the map is moved, zoomed, or anything else that
       * would effect positions, to redraw this overlay.
       */
    CustomWindow.prototype.draw = function () {var _map$getDiv =
      this.map.getDiv(),mapWidth = _map$getDiv.offsetWidth,mapHeight = _map$getDiv.offsetHeight;
      var pinPosition = this.marker.getPosition();
      var containerMetrics = this.container.getBoundingClientRect();

      var pinOffsets = getDistanceBetweenPointAndMapBorders(this.map, pinPosition, mapHeight, mapWidth);
      var infoWindowOffsets = calculateInfoWindowPosition(pinOffsets, containerMetrics.height, containerMetrics.width);

      this.position = this.getProjection().fromLatLngToDivPixel(pinPosition);
      this.position.x -= 1; // Fix strange offset from point for 1 pixel

      this.container.style.top = this.position.y + infoWindowOffsets.offsetY + 'px';
      this.container.style.left = this.position.x - infoWindowOffsets.offsetX + 'px';

      var arrow = this.container.querySelector('.map-info-arrow');
      arrow.style.left = calculateArrowPosition(
      mapWidth,
      containerMetrics.width,
      pinOffsets.left,
      infoWindowOffsets.offsetX);


      if (infoWindowOffsets.isArrowAtTop) {
        arrow.style.transform = 'rotate(180deg) translateY(' + containerMetrics.height + 'px)';
      }
    };

    /**
        * Called when this overlay has its map set to null.
        * @see CustomWindow.close
        */
    CustomWindow.prototype.onRemove = function () {
      this.layer.removeChild(this.container);
    };

    /**
        * Sets the contents of this overlay.
        * @param {string} html
        */
    CustomWindow.prototype.setContent = function (html) {
      if ((0, _get2.default)(html, 'props.multiple')) {
        this.container.classList.add('multiple-map-info-window');
      }
      _reactDom2.default.render(html, this.container.lastChild);
    };

    /**
        * Sets the map and relevant marker for this overlay.
        * @param {google.maps.Map} map
        * @param {google.maps.Marker} marker
        */
    CustomWindow.prototype.open = function (map, marker) {
      this.marker = marker;
      this.setMap(map);
    };

    /**
        * Close this overlay by setting its map to null.
        */
    CustomWindow.prototype.close = function () {
      this.setMap(null);
    };

    return CustomWindow;
  }();};
/* eslint-disable */ /* eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/utils/createCustomGoogleInfoWindow.js
// module id = 3090
// module chunks = 0